import { RootStateOrAny } from 'react-redux';
import { PreviewCardParams } from '../../organisms/MovieItem/types';
import { Purchase } from '../../../domain/entities';
import {
  FETCH_PURCHASE_REQUEST,
  FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_REQUEST,
} from '../../../redux/purchase/actionType';
import { DOWNLOAD_FILE_REQUEST } from '../../../redux/projectContent/actionType';
import { DOWNLOAD_FILE_REQUEST as DOWNLOAD_EA_FILE_REQUEST } from '../../../redux/EAProgram/actionType';

export type StateFromProps = {
  purchasedVideosAndProjectsAndEAPrograms: {
    videos: Array<PreviewCardParams>;
    projectContents: Array<PreviewCardParams>;
    eaPrograms: Array<PreviewCardParams>;
  };
  userId: string;
  purchases: { [key: string]: Purchase };
  isFetchingPurchases: boolean;
  currentProjectFileToBlob: Blob;
  currentEAProgramFileToBlob: Blob;
  isDownloadingProjectContent: boolean;
  isDownloadingEAContent: boolean;
  isFetchingPurchasedItems: boolean;
};

export default (state: RootStateOrAny): StateFromProps => {
  const {
    user: { id },
    purchase: { purchasedVideosAndProjectsAndEAPrograms, purchases, requests },
    projectContent: { currentProjectFileBlob, requests: projectRequests },
    EAProgram: { currentEAProgramFileBlob, requests: eaProgramRequests },
  } = state;

  const isFetchingPurchases =
    requests &&
    requests[FETCH_PURCHASE_REQUEST] &&
    (requests[FETCH_PURCHASE_REQUEST].pending as boolean);

  const isFetchingPurchasedItems =
    requests &&
    requests[FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_REQUEST] &&
    (requests[FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_REQUEST]
      .pending as boolean);

  const videos = purchasedVideosAndProjectsAndEAPrograms.videoLectures;
  const projectContents =
    purchasedVideosAndProjectsAndEAPrograms.projectContents;
  const eaPrograms = purchasedVideosAndProjectsAndEAPrograms.eaPrograms;

  const currentProjectFileToBlob =
    currentProjectFileBlob && currentProjectFileBlob[DOWNLOAD_FILE_REQUEST];

  const currentEAProgramFileToBlob =
    currentEAProgramFileBlob &&
    currentEAProgramFileBlob[DOWNLOAD_EA_FILE_REQUEST];

  const isDownloadingProjectContent =
    projectRequests &&
    projectRequests[DOWNLOAD_FILE_REQUEST] &&
    (projectRequests[DOWNLOAD_FILE_REQUEST].pending as boolean);

  const isDownloadingEAContent =
    eaProgramRequests &&
    eaProgramRequests[DOWNLOAD_EA_FILE_REQUEST] &&
    (eaProgramRequests[DOWNLOAD_EA_FILE_REQUEST].pending as boolean);

  return {
    purchasedVideosAndProjectsAndEAPrograms: {
      videos,
      projectContents,
      eaPrograms,
    },
    userId: id,
    purchases,
    isFetchingPurchases,
    currentProjectFileToBlob,
    currentEAProgramFileToBlob,
    isDownloadingProjectContent,
    isDownloadingEAContent,
    isFetchingPurchasedItems,
  };
};
